import { render, staticRenderFns } from "./PersonalStatsSection.vue?vue&type=template&id=78c9bd89&scoped=true"
import script from "./PersonalStatsSection.vue?vue&type=script&lang=js"
export * from "./PersonalStatsSection.vue?vue&type=script&lang=js"
import style0 from "./PersonalStatsSection.vue?vue&type=style&index=0&id=78c9bd89&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c9bd89",
  null
  
)

export default component.exports